// extracted by mini-css-extract-plugin
export var searchHeader = "_7r-0";
export var searchHeaderDark = "_7r-1";